const registerCopyToClipboardListener = () => {
  const elementsWithClipboardData = document.querySelectorAll<HTMLElement>('[data-clipboard]');

  elementsWithClipboardData.forEach((elementWithClipboardData) => {
    elementWithClipboardData.addEventListener('click', () => {
      try {
        const clipboardData = elementWithClipboardData.dataset.clipboard;
        if (clipboardData) {
          navigator.clipboard.writeText(clipboardData);
        } else {
          console.log('The clipboard data is missing.');
        }
      } catch (err) {
        console.log('Failed to copy to clipboard:', err);
      }
    });
  });
};

export { registerCopyToClipboardListener };
